const palette = {
  red050: '#ffeaed',
  red100: '#ffccd0',
  red200: '#f39896',
  red300: '#ea6f6d',
  red350: '#E46262DE', // main for dark mode
  red400: '#f44d47',
  red500: '#f83b29',
  red600: '#ea302a',
  red700: '#d82424', // main for light mode
  red750: '#b0050e',
  red800: '#cb1b1d',
  red900: '#bd040e',

  yellow50: '#FFFDE7',
  yellow100: '#FFF9C4',

  grey050: '#f9f9f9',
  grey100: '#f2f2f2',
  grey200: '#eaeaea',
  grey250: '#E0E0E0',
  grey300: '#dadada',
  grey350: '#cccccc',
  grey400: '#b6b6b6',
  grey500: '#979797',
  grey600: '#6e6e6e',
  grey700: '#5b5b5b',
  grey800: '#3c3c3c',
  grey900: '#1c1c1c',

  orange500: '#B8660F',

  blue500: '#0D86BA',
  blue200: '#3b82f6',
  blue800: '#212131',
  blue850: '#1a1a28',
  blue700: '#41404f',
  blue900: '#111122',

  green500: '#607703',
}

const _base = {
  fonts: {
    title: "'Roboto', sans-serif",
    titleWeight: 700,
    text: "'Roboto', sans-serif",
    textWeight: 400,
  },
}

export const light = {
  ..._base,

  colors: {
    main: palette.red800,
    accent: palette.red800,
    background: palette.grey050,
    foreground: palette.grey200,
    foregroundPaper: palette.grey100,
    selectable: palette.grey300,
    moveTo: palette.grey400,
    bottomActionBar: palette.grey300,
    avatar: palette.red350,

    tileForeground: palette.grey050,
    tileBehindCurrentWeek: palette.grey250,
    tileAheadCurrentWeek: palette.yellow50,

    inputTextBackground: palette.grey100,
    inputTextBoxBackground: palette.grey200,

    switchSlider: palette.red350,

    headerBackground: palette.red800,
    headerText: palette.grey050,

    datePickerBackground: palette.grey200,

    buttonPrimaryText: palette.grey050,
    buttonPrimaryColor: palette.red800,
    buttonPressedPrimaryColor: palette.red750,
    buttonPrimaryBorderColor: palette.red800,
    buttonPressedSecondaryColor: palette.grey350,
    buttonSecondaryText: palette.grey900,
    buttonSecondaryColor: palette.grey300,
    buttonSecondaryBorderColor: palette.grey300,

    text: palette.grey800,
    info: palette.grey700,
    textDisabled: palette.grey500,
    textLink: palette.blue200,
    textError: palette.red800,
    textSelection: palette.grey500,
    textPill: palette.grey100,

    textFormDisabled: palette.grey300,
    textForm: palette.grey800,
    formBorder: palette.grey800,
    formBorderDisabled: palette.grey300,

    tabBarInactive: palette.red300,
    tabBarActive: palette.grey050,
    tabBarBackground: palette.red800,

    offlineStatus: {
      offlineText: palette.grey250,
      offlineBackground: palette.grey900,
    },

    taskStatus: {
      undefined: palette.grey500,
      todo: '#ED8B24',
      inProgress: '#0FA3E0',
      completed: '#B4D430',
      scheduled: '#969696',
      permitNeeded: '#ED8B00',
      notReady: '#AD1723',
      ready: '#00A3E0',
    },

    taskTeco: '#4E9A26',
    hasBarrier: '#7a4183',
    isReset: '#ed8b00',
    isPullAhead: '#ed8b00',
    isSplit: '#111122',
    isBreakIn: '#969696',

    gradientSignIn: [
      palette.red900,
      palette.red800,
      palette.red100,
      palette.red050,
      palette.red050,
      palette.red050,
    ],
    gradientMain: [palette.red900, palette.red800, palette.red400],
  },
}

export const dark = {
  ..._base,

  colors: {
    main: palette.red350,
    accent: palette.red350,
    background: palette.blue900,
    foreground: palette.blue800,
    foregroundPaper: palette.blue800,
    selectable: palette.blue700,
    headerBackground: palette.blue800,
    headerText: palette.grey050,
    moveTo: palette.blue700,
    bottomActionBar: palette.blue700,
    avatar: palette.grey500,

    inputTextBackground: palette.blue900,
    inputTextBoxBackground: palette.blue800,

    datePickerBackground: palette.blue800,

    switchSlider: palette.red350,

    tileForeground: palette.blue800,
    tileBehindCurrentWeek: palette.blue900,
    tileAheadCurrentWeek: palette.blue700,

    buttonPrimaryText: palette.grey050,
    buttonPrimaryColor: palette.red900,
    buttonPressedPrimaryColor: palette.red750,
    buttonPressedSecondaryColor: palette.blue850,
    buttonPrimaryBorderColor: palette.red900,
    buttonSecondaryText: palette.grey250,
    buttonSecondaryColor: palette.blue800,
    buttonSecondaryBorderColor: palette.grey250,

    text: palette.grey250,
    info: palette.grey300,
    textDisabled: palette.grey500,
    textLink: palette.blue200,
    textError: palette.red800,
    textSelection: palette.grey500,
    textPill: palette.grey100,

    textFormDisabled: palette.grey700,
    textForm: palette.grey250,
    formBorder: palette.grey250,
    formBorderDisabled: palette.grey700,

    tabBarInactive: palette.grey600,
    tabBarActive: palette.grey250,
    tabBarBackground: palette.blue800,

    offlineStatus: {
      offlineText: palette.grey250,
      offlineBackground: palette.red800,
    },

    taskStatus: {
      undefined: palette.grey500,
      todo: '#ED8B24',
      inProgress: '#0FA3E0',
      completed: '#B4D430',
      scheduled: '#969696',
      permitNeeded: '#ED8B00',
      notReady: '#AD1723',
      ready: '#00A3E0',
    },

    taskTeco: '#4E9A26',
    hasBarrier: '#7a4183',
    isReset: '#ed8b00',
    isPullAhead: '#ed8b00',
    isSplit: '#111122',
    isBreakIn: '#969696',

    gradientSignIn: [
      palette.red900,
      palette.red800,
      palette.red100,
      palette.red050,
      palette.red050,
      palette.red050,
    ],
    gradientMain: [palette.grey800, palette.grey900],
  },
}

export default light
